import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useEmojiStyles = createUseStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.colors.dark_chocolate,
    padding: theme.spacing(6),
    textAlign: 'center',
    minHeight: '75vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(-1),
    },
  },
  title: {
    color: theme.colors.ivory_beige,
    fontFamily: theme.fonts.poplar,
    fontSize: '3rem',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(4),
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
      marginTop: theme.spacing(2),
    },
  },
  description: {
    color: theme.palette.primary.light,
    fontSize: '1.2rem',
    marginBottom: theme.spacing(6),
    maxWidth: '800px',
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
      padding: '0 16px',
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
      lineHeight: 1.5,
    },
  },
  templatesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(6),
    width: '100%',
    maxWidth: '900px',
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(2),
      marginBottom: theme.spacing(4),
      maxWidth: '400px',
    },
  },
  arrowButton: {
    backgroundColor: theme.colors.golden_mustard,
    color: theme.colors.espresso_brown,
    width: '60px',
    height: '60px',
    transition: 'all 0.3s ease',
    fontSize: '1.5rem',
    '&:hover': {
      backgroundColor: theme.colors.desert_sand_gold,
      transform: 'scale(1.1)',
    },
    [theme.breakpoints.down('md')]: {
      width: '50px',
      height: '50px',
      fontSize: '1.2rem',
    },
  },
  templatesRowDesktop: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  templatesRowMobile: {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  templateCircle: {
    width: '160px',
    height: '160px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    border: '1px solid transparent',
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      width: '200px',
      height: '200px',
      padding: theme.spacing(2.5),
    },
  },
  selectedTemplate: {
    border: `2px solid ${theme.colors.golden_mustard}`,
    backgroundColor: theme.colors.ivory_beige,
    transform: 'scale(1.3)',
    boxShadow: '0 12px 35px rgba(209, 168, 94, 0.6)',
    zIndex: 10,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      transform: 'scale(1)',
      border: `2px solid ${theme.colors.golden_mustard}`,
    },
  },
  inactiveTemplate: {
    opacity: 0.4,
    transform: 'scale(0.85)',
    filter: 'grayscale(0.3)',
    '&:hover': {
      opacity: 0.6,
      transform: 'scale(0.9)',
    },
  },
  stencilImage: {
    width: '100%',
    height: '100%',
    filter: 'contrast(1.2)',
  },
  downloadButton: {
    backgroundColor: theme.colors.golden_mustard,
    color: theme.colors.espresso_brown,
    fontFamily: theme.fonts.poplar,
    fontSize: '1.7rem',
    marginTop: theme.spacing(2),
    padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: theme.colors.desert_sand_gold,
      transform: 'translateY(-3px)',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.1rem',
      padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      width: '90%',
      maxWidth: '320px',
    },
  },
}));

export default useEmojiStyles;